import React from 'react';
import MoneyFormat from "../../layout/MoneyFormat";

const SparePartAbout = ({ sparePart }) => {
    if (!sparePart) {
        return <div>Ehtiyot qismi ma'lumotlari yuklanmoqda...</div>;
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header">
                        <h5 className="card-title mb-0">Ehtiyot qismi ma'lumotlari</h5>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="d-flex align-items-center border-bottom py-2">
                                    <div className="fw-bold" style={{minWidth: '120px'}}>Nomi:</div>
                                    <div className="text-muted ms-2">{sparePart.name || '-'}</div>
                                </div>
                                
                                <div className="d-flex align-items-center border-bottom py-2">
                                    <div className="fw-bold" style={{minWidth: '120px'}}>Qolgan miqdor:</div>
                                    <div className="text-muted ms-2">
                                        {sparePart.in_stock || 0} {sparePart.unit?.symbol || sparePart.unit?.name || ''}
                                    </div>
                                </div>
                                
                                <div className="d-flex align-items-center border-bottom py-2">
                                    <div className="fw-bold" style={{minWidth: '120px'}}>Narxi:</div>
                                    <div className="text-muted ms-2">
                                        <MoneyFormat value={sparePart.price || 0}/> so'm
                                    </div>
                                </div>
                                
                                <div className="d-flex align-items-center border-bottom py-2">
                                    <div className="fw-bold" style={{minWidth: '120px'}}>O'lchov birligi:</div>
                                    <div className="text-muted ms-2">{sparePart.unit?.name || '-'}</div>
                                </div>
                            </div>
                            
                            <div className="col-md-6">
                                <div className="d-flex align-items-center border-bottom py-2">
                                    <div className="fw-bold" style={{minWidth: '120px'}}>Firma:</div>
                                    <div className="text-muted ms-2">{sparePart.firm?.name || '-'}</div>
                                </div>
                                
                                <div className="d-flex align-items-center border-bottom py-2">
                                    <div className="fw-bold" style={{minWidth: '120px'}}>Sklad:</div>
                                    <div className="text-muted ms-2">{sparePart.warehouse?.name || '-'}</div>
                                </div>
                                
                                <div className="d-flex align-items-center border-bottom py-2">
                                    <div className="fw-bold" style={{minWidth: '120px'}}>Yaratilgan:</div>
                                    <div className="text-muted ms-2">
                                        {sparePart.created_at ? new Date(sparePart.created_at).toLocaleDateString('uz-UZ') : '-'}
                                    </div>
                                </div>
                                
                                <div className="d-flex align-items-center border-bottom py-2">
                                    <div className="fw-bold" style={{minWidth: '120px'}}>Tavsif:</div>
                                    <div className="text-muted ms-2">{sparePart.description || '-'}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SparePartAbout; 